import React from "react";
import Info from "@material-ui/icons/Info";
import Warning from "@material-ui/icons/Warning";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Error from "@material-ui/icons/Error";
import Close from "@material-ui/icons/Close";
import Snackbar, { SnackbarOrigin } from "@material-ui/core/Snackbar";
import { SnackbarContent } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { SnackbarMessageTypes, ISnackbarMessage } from "./SnackbarService";
import Theme from "../../Theme";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

const CloseIcon = styled(Close)`
  color: ${Theme.colors.white};
  font-size: "20px";
`;

const InfoTypography = styled(Typography)`
  background-color: ${Theme.colors.info};
  display: "flex";
`;

const WarningTypography = styled(Typography)`
  background-color: ${Theme.colors.warning};
  display: "flex";
`;

const ErrorTypography = styled(Typography)`
  background-color: ${Theme.colors.error};
  display: "flex";
`;
const SuccessTypography = styled(Typography)`
  background-color: ${Theme.colors.success};
  display: "flex";
`;

const useStyles = makeStyles(() => ({
  success: {
    backgroundColor: Theme.colors.success,
  },
  error: {
    backgroundColor: Theme.colors.error,
  },
  info: {
    backgroundColor: Theme.colors.info,
  },
  warning: {
    backgroundColor: Theme.colors.warning,
  },
  icon: {
    fontSize: 20,
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
}));

export const GlobalSnackbar = (props: { message: ISnackbarMessage; seconds?: number }) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles({});

  const getTypography = () => {
    switch (props.message.messageType) {
      case SnackbarMessageTypes.Info:
        return (
          <InfoTypography>
            {getIcon()} {props.message.messageText}
          </InfoTypography>
        );
      case SnackbarMessageTypes.Warning:
        return (
          <WarningTypography>
            {getIcon()} {props.message.messageText}
          </WarningTypography>
        );
      case SnackbarMessageTypes.Error:
        return (
          <ErrorTypography>
            {getIcon()} {props.message.messageText}
          </ErrorTypography>
        );
      default:
        return (
          <SuccessTypography>
            {getIcon()} {props.message.messageText}
          </SuccessTypography>
        );
    }
  };

  const getStyle = () => {
    switch (props.message.messageType) {
      case SnackbarMessageTypes.Info:
        return classes.info;
      case SnackbarMessageTypes.Warning:
        return classes.warning;
      case SnackbarMessageTypes.Success:
        return classes.success;
      case SnackbarMessageTypes.Error:
      default:
        return classes.error;
    }
  };

  const getIcon = () => {
    switch (props.message.messageType) {
      case SnackbarMessageTypes.Info:
        return <Info className={classes.icon} />;
      case SnackbarMessageTypes.Warning:
        return <Warning className={classes.icon} />;
      case SnackbarMessageTypes.Success:
        return <CheckCircle className={classes.icon} />;
      case SnackbarMessageTypes.Error:
      default:
        return <Error className={classes.icon} />;
    }
  };

  const onClose = () => setOpen(false);

  React.useEffect(() => {
    if (props.message && props.message.messageText !== "") {
      setOpen(true);
      setTimeout(() => {
        setOpen(false);
      }, props.seconds || 5000);
    }
  }, [props.message]);

  const anchorOrigin: SnackbarOrigin = {
    horizontal: "left",
    vertical: "bottom",
  };

  return (
    <Snackbar anchorOrigin={anchorOrigin} open={open} className={getStyle()}>
      <SnackbarContent
        className={getStyle()}
        message={getTypography()}
        action={
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        }
      />
    </Snackbar>
  );
};
